import MainTitle from "../../components/MainTitle";
import Payslip from "../../components/Payslip";

import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useParams } from "react-router-dom";

function AccountPayslips() {
  const { serviceType } = useParams();
  const [practitioners, setPractitioners] = useState([]);

  const { setShowLoader } = useAuth();
  const axios = useAxiosPrivate();

  const getPractitioners = async () => {
    try {
      setShowLoader(true);
      const response = await axios.get(`/users/all`);
      await setPractitioners(response.data.result);
    } catch (error) {}
    setShowLoader(false);
  };

  useEffect(() => {
    getPractitioners();
  }, []);

  return (
    <section>
      <MainTitle title="Worklogs" />

      <Payslip practitioners={practitioners} serviceType={serviceType} />
    </section>
  );
}

export default AccountPayslips;
